(function () {
    'use strict';

    angular
        .module('app')
        .controller('CustomSelectController', CustomSelectController);

    CustomSelectController.$inject = [];

    function CustomSelectController() {
        var CustomSelect = this;
        CustomSelect.$onInit = init;
        CustomSelect.toggle = toggle;
        CustomSelect.is_selected = is_selected;

        function init(){

        }

        function toggle(option){
            if(is_selected(option)){
                CustomSelect.selectedOptions.splice(CustomSelect.selectedOptions.indexOf(option), 1);
            } else {
                if(CustomSelect.config.max !== undefined  && CustomSelect.selectedOptions.length >= CustomSelect.config.max) return false;
                CustomSelect.selectedOptions.push(option);
            }
        }

        function is_selected(option){
            var is_selected = false;
            angular.forEach(CustomSelect.selectedOptions, function(selected_option){
                if(option.filter_value_id == selected_option.filter_value_id){
                    is_selected = true;
                }
            });

            return is_selected;
        }
    }
})();